import { render, staticRenderFns } from "./DocuformsPage.vue?vue&type=template&id=17dab867&scoped=true"
import script from "./DocuformsPage.vue?vue&type=script&lang=js"
export * from "./DocuformsPage.vue?vue&type=script&lang=js"
import style0 from "./DocuformsPage.vue?vue&type=style&index=0&id=17dab867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dab867",
  null
  
)

export default component.exports